import { render, staticRenderFns } from "./TrendyolProductMessage.vue?vue&type=template&id=d4f61362&scoped=true"
import script from "./TrendyolProductMessage.vue?vue&type=script&lang=js"
export * from "./TrendyolProductMessage.vue?vue&type=script&lang=js"
import style0 from "./TrendyolProductMessage.vue?vue&type=style&index=0&id=d4f61362&prod&lang=scss&scoped=true"
import style1 from "./TrendyolProductMessage.vue?vue&type=style&index=1&id=d4f61362&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4f61362",
  null
  
)

export default component.exports